import { Reducer } from 'redux';
import {
    CropsActionTypes,
    GET_CROPS_TYPES_SUCCESS,
    LOAD_CROPS_LISTING,
    LOAD_CROPS_LISTING_SUCCESS,
} from '../actions/CropsActions';
import CropsState from '../models/CropsState';

const initialState: CropsState = {
  data: {},
  crops_type: {},
  cropping_systems: {},
};

const cropsReducers: Reducer<CropsState, CropsActionTypes> = (state: CropsState = initialState, action: CropsActionTypes) => {
  switch (action.type) {
    case LOAD_CROPS_LISTING:
      return {
        ...state,
      };
    case LOAD_CROPS_LISTING_SUCCESS:
      return {
        ...state,
        data: action.payload.crops,
        crops_type: action.payload.cropsTypes,
        cropping_systems: action.payload.croppingSystems,
      };
    case GET_CROPS_TYPES_SUCCESS:
        return {
            ...state,
            crops_type: action.payload,
        }
    default:
      return state;
  }
};
export default cropsReducers;
